<template>
    <!-- Editar varios espacios a la vez (diseño de la demo Desktop/nuevo-editaralojamiento):
         1) qué cambias, 2) el nuevo valor, 3) en qué espacios, con "antes → después".
         API: GET/POST accommodations/masivo (solo los espacios del usuario) y
         POST accommodations/masivo/deshacer. -->
    <div class="ee">
        <div class="ee-lay ee-ms">
            <aside class="ee-side">
                <h1 ref="titulo" class="ee-side-title" tabindex="-1">{{ $t('editor_espacio.title_a') }} <span class="ee-grad">{{ $t('editor_espacio.ms.title_b') }}</span></h1>
                <p class="ee-side-sub">{{ $t('editor_espacio.ms.sub') }}</p>
                <ol class="ee-msteps">
                    <li :class="{ 'is-done': !!accion }"><span class="ee-msteps-n">1</span><span><b>{{ $t('editor_espacio.ms.s1') }}</b><small>{{ accion ? $t(`editor_espacio.ms.a.${accion}`) : $t('editor_espacio.ms.s1_none') }}</small></span></li>
                    <li :class="{ 'is-done': !!accion && listoParams }"><span class="ee-msteps-n">2</span><span><b>{{ $t('editor_espacio.ms.s2') }}</b><small>{{ accion ? resumenParams : '—' }}</small></span></li>
                    <li :class="{ 'is-done': elegidos.length > 0 }"><span class="ee-msteps-n">3</span><span><b>{{ $t('editor_espacio.ms.s3') }}</b><small>{{ elegidos.length ? $tc('editor_espacio.ms.n_chosen', elegidos.length, { n: elegidos.length }) : $t('editor_espacio.ms.none_chosen') }}</small></span></li>
                </ol>
                <p v-if="desde" class="ee-ms-desde"><span v-html="ICON.layers"></span><span>{{ $t('editor_espacio.ms.copying_from') }} <b>{{ desde }}</b>.</span></p>
            </aside>

            <div class="ee-main">
                <div class="ee-crumb"><router-link class="ee-crumb-back" :to="{ name: 'my-accommodations' }"><span v-html="ICON.back"></span>{{ $t('editor_espacio.my_spaces') }}</router-link></div>

                <section id="msC1" :class="['ee-card', { 'is-done': !!accion }]" aria-labelledby="msT1">
                    <div class="ee-card-head"><span class="ee-step">1</span><div><h2 id="msT1" class="ee-card-title">{{ $t('editor_espacio.ms.q1') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.ms.q1_c') }}</p></div></div>
                    <div class="ee-acc" role="radiogroup" aria-labelledby="msT1">
                        <label v-for="a in acciones" :key="a.id" class="ee-acc-o">
                            <input type="radio" name="accion" :value="a.id" :checked="accion === a.id" @change="elegirAccion(a.id)">
                            <span><i aria-hidden="true" v-html="ICON[a.icon]"></i><b>{{ $t(`editor_espacio.ms.a.${a.id}`) }}</b><small>{{ $t(`editor_espacio.ms.a.${a.id}_c`) }}</small></span>
                        </label>
                    </div>
                </section>

                <section id="msC2" :class="['ee-card', { 'is-done': !!accion && listoParams }]" aria-labelledby="msT2">
                    <div class="ee-card-head"><span class="ee-step">2</span><div><h2 id="msT2" class="ee-card-title">{{ $t('editor_espacio.ms.q2') }}</h2><p class="ee-card-desc">{{ accion ? $t(`editor_espacio.ms.d.${accion}`) : $t('editor_espacio.ms.q2_none') }}</p></div></div>
                    <div id="msForm">
                        <!-- Precio -->
                        <template v-if="accion === 'precio'">
                            <fieldset class="ee-choice"><legend>{{ $t('editor_espacio.ms.which_price') }}</legend>
                                <div class="ee-seg" role="radiogroup"><label v-for="c in CAMPOS" :key="c.v" class="ee-seg-o"><input v-model="p.campo" type="radio" name="pc" :value="c.v"><span>{{ $t(c.l) }}</span></label></div>
                            </fieldset>
                            <fieldset class="ee-choice"><legend>{{ $t('editor_espacio.ms.how') }}</legend>
                                <div class="ee-seg" role="radiogroup"><label v-for="m in ['fijar', 'pct', 'monto']" :key="m" class="ee-seg-o"><input type="radio" name="pm" :value="m" :checked="p.modo === m" @change="elegirModo(m)"><span>{{ $t(`editor_espacio.ms.mode_${m}`) }}</span></label></div>
                            </fieldset>
                            <div class="ee-grid-2">
                                <div class="ee-field ee-has-suf">
                                    <div class="ee-control">
                                        <input id="pv" v-model="p.valor" type="number" :inputmode="p.modo === 'pct' ? 'decimal' : 'numeric'" :step="p.modo === 'pct' ? 'any' : 1" :min="p.modo === 'fijar' ? 0 : null" placeholder=" ">
                                        <label for="pv">{{ $t(`editor_espacio.ms.value_${p.modo}`) }}</label>
                                        <span class="ee-suf" aria-hidden="true">{{ p.modo === 'pct' ? '%' : p.moneda }}</span>
                                    </div>
                                    <p v-if="p.modo === 'pct'" class="ee-hint">{{ $t('editor_espacio.ms.pct_hint') }}</p>
                                </div>
                                <div class="ee-field">
                                    <div class="ee-control">
                                        <select id="pmon" v-model="p.moneda">
                                            <option v-if="p.modo === 'pct'" value="">{{ $t('editor_espacio.ms.keep_currency') }}</option>
                                            <option v-for="m in monedas" :key="m" :value="m">{{ m }}</option>
                                        </select>
                                        <label for="pmon">{{ $t('editor_espacio.ms.save_currency') }}</label>
                                    </div>
                                </div>
                            </div>
                            <p class="ee-ed-note ee-ed-note--soft"><span v-html="ICON.info"></span><span>{{ p.moneda ? $t('editor_espacio.ms.convert_note', { m: p.moneda }) : $t('editor_espacio.ms.keep_note') }}</span></p>

                            <!-- Garantía junto con el precio (solo modelo garantía y precio mensual) -->
                            <template v-if="modeloGarantia && p.campo !== 'arriendo_diario'">
                                <fieldset class="ee-choice ee-ms-gar"><legend>{{ $t('editor_espacio.ms.g_title') }} · {{ $t('wizard.s2.guarantee-question') }}</legend>
                                    <div class="ee-mo ee-mo--keep" role="radiogroup">
                                        <label class="ee-mo-o ee-mo-o--keep"><input v-model="p.gMeses" type="radio" name="pgm" value=""><span><b>=</b><small>{{ $t('editor_espacio.ms.g_keep') }}</small></span></label>
                                        <label v-for="m in GARANTIA_MESES" :key="m" class="ee-mo-o"><input v-model="p.gMeses" type="radio" name="pgm" :value="String(m)"><span><b>{{ mesesNum(m) }}</b><small>{{ mesesUnidad(m) }}</small></span></label>
                                    </div>
                                </fieldset>
                                <fieldset v-if="p.gMeses !== '' && +p.gMeses > 0" class="ee-choice"><legend>{{ $t('wizard.s2.guarantee-when') }}</legend>
                                    <div class="ee-rd"><label v-for="g in GARANTIA_PAGO" :key="g" class="ee-rd-o"><input v-model="p.gPago" type="radio" name="pgp" :value="g"><span>{{ $t(`wizard.s2.guarantee-when-${g}`) }}</span></label></div>
                                </fieldset>
                                <p v-if="p.gMeses !== '' && +p.gMeses > 0" class="ee-ed-note ee-ed-note--soft"><span v-html="ICON.info"></span><span>{{ $t('editor_espacio.ms.g_note') }}</span></p>
                            </template>
                        </template>

                        <div v-else-if="accion === 'estadia' || accion === 'huespedes'" class="ee-cts ee-cts--1">
                            <EeContador id="mv" v-model="p.valor" :label="$t(accion === 'estadia' ? 'editor_espacio.f.min_nights' : 'editor_espacio.f.max_guests')" :min="1" :max="accion === 'estadia' ? 365 : 20" />
                        </div>

                        <div v-else-if="accion === 'modalidad'" class="ee-seg" role="radiogroup">
                            <label v-for="m in MODALIDADES" :key="m" class="ee-seg-o"><input v-model="p.valor" type="radio" name="mm" :value="m"><span>{{ $t(`editor_espacio.mod.${m}`) }}</span></label>
                        </div>

                        <template v-else-if="accion === 'garantia'">
                            <fieldset class="ee-choice"><legend>{{ $t('wizard.s2.guarantee-question') }}</legend>
                                <div class="ee-mo" role="radiogroup"><label v-for="m in GARANTIA_MESES" :key="m" class="ee-mo-o"><input v-model.number="p.meses" type="radio" name="gm" :value="m"><span><b>{{ mesesNum(m) }}</b><small>{{ mesesUnidad(m) }}</small></span></label></div>
                            </fieldset>
                            <fieldset v-if="p.meses > 0" class="ee-choice"><legend>{{ $t('wizard.s2.guarantee-when') }}</legend>
                                <div class="ee-rd"><label v-for="g in GARANTIA_PAGO" :key="g" class="ee-rd-o"><input v-model="p.pago" type="radio" name="gp" :value="g"><span>{{ $t(`wizard.s2.guarantee-when-${g}`) }}</span></label></div>
                            </fieldset>
                        </template>

                        <template v-else-if="accion === 'reglas'">
                            <fieldset class="ee-choice"><legend>{{ $t('editor_espacio.ms.which_texts') }}</legend>
                                <div class="ee-tg"><label v-for="t in TEXTOS" :key="t" class="ee-tg-o"><input type="checkbox" :checked="t in p.textos" @change="alternarTexto(t, $event.target.checked)"><span><i class="ee-i" v-html="ICON.rules"></i>{{ $t(`editor_espacio.tx.${t}`) }}</span></label></div>
                            </fieldset>
                            <fieldset class="ee-choice"><legend>{{ $t('editor_espacio.ms.how') }}</legend>
                                <div class="ee-seg" role="radiogroup"><label v-for="m in ['reemplazar', 'agregar']" :key="m" class="ee-seg-o"><input v-model="p.modo" type="radio" name="rm" :value="m"><span>{{ $t(`editor_espacio.ms.text_${m}`) }}</span></label></div>
                            </fieldset>
                            <EeTexto v-for="t in TEXTOS.filter(x => x in p.textos)" :id="`f-${t}`" :key="t" v-model="p.textos[t]" :label="$t(`editor_espacio.tx.${t}`)" :ayuda="$t(`editor_espacio.tx.${t}_c`)" :max="1500" />
                        </template>

                        <template v-else-if="accion === 'sobre'">
                            <div class="ee-seg" role="radiogroup"><label v-for="m in ['reemplazar', 'agregar']" :key="m" class="ee-seg-o"><input v-model="p.modo" type="radio" name="sm" :value="m"><span>{{ $t(`editor_espacio.ms.text_${m}`) }}</span></label></div>
                            <div class="ee-ms-gap"></div>
                            <EeTexto id="f-sobre_nosotros" v-model="p.valor" :label="$t('wizard.s7.about-us')" :ayuda="$t('editor_espacio.b.sobre_c')" :max="1200" />
                        </template>

                        <template v-else-if="accion === 'comodidades' || accion === 'cercano'">
                            <template v-for="g in gruposTri">
                                <p :key="g.grupo + '-t'" class="ee-ed-sub">{{ g.titulo }}</p>
                                <ul :key="g.grupo" class="ee-tri">
                                    <li v-for="[k, l, ic] in g.items" :key="k" :class="['ee-tri-r', p.cambios[k] ? 'is-' + p.cambios[k] : '']">
                                        <span class="ee-tri-l"><i class="ee-i" v-html="amen(ic)"></i>{{ $t(l) }}</span>
                                        <span class="ee-tri-c" role="radiogroup" :aria-label="$t(l)">
                                            <label v-for="[val, txt] in [['', 'same'], ['agregar', 'add'], ['quitar', 'remove']]" :key="val"><input type="radio" :name="`tri-${k}`" :value="val" :checked="(p.cambios[k] || '') === val" @change="alternarTri(k, val)"><span>{{ $t(`editor_espacio.ms.${txt}`) }}</span></label>
                                        </span>
                                    </li>
                                </ul>
                            </template>
                        </template>
                    </div>
                </section>

                <section id="msC3" :class="['ee-card', { 'is-done': elegidos.length > 0 }]" aria-labelledby="msT3">
                    <div class="ee-card-head"><span class="ee-step">3</span><div><h2 id="msT3" class="ee-card-title">{{ $t('editor_espacio.ms.q3') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.ms.q3_c') }}</p></div></div>
                    <div class="ee-ms-tools">
                        <div class="ee-search"><span v-html="ICON.search"></span><input id="msQ" v-model="f.q" type="search" :placeholder="$t('editor_espacio.ms.search')" :aria-label="$t('editor_espacio.ms.search')"></div>
                        <div class="ee-filters" role="group">
                            <button v-for="[v, l] in [['todos', 'all'], ['ok', 'published'], ['wait', 'in_review']]" :key="v" type="button" class="ee-filter" :aria-pressed="String(f.estado === v)" @click="f.estado = v">{{ $t(v === 'todos' ? 'editor_espacio.ms.all' : `editor_espacio.${l}`) }}</button>
                        </div>
                        <div class="ee-ms-sel">
                            <select v-model="f.ciudad" :aria-label="$t('editor_espacio.ms.city')"><option value="">{{ $t('editor_espacio.ms.all_cities') }}</option><option v-for="c in ciudades" :key="c" :value="c">{{ c }}</option></select>
                            <select v-model="f.tipo" :aria-label="$t('editor_espacio.ms.type')"><option value="">{{ $t('editor_espacio.ms.all_types') }}</option><option value="entero">{{ $t('editor_espacio.tipo.entero') }}</option><option value="privado">{{ $t('editor_espacio.tipo.privado') }}</option></select>
                        </div>
                    </div>
                    <div class="ee-ms-head">
                        <label class="ee-ck"><input id="msAll" ref="todos" type="checkbox" :checked="todosVisibles" @change="elegirVisibles($event.target.checked)"><span>{{ visibles.length === lista.length ? $t('editor_espacio.ms.select_all', { n: visibles.length }) : $t('editor_espacio.ms.select_visible', { n: visibles.length }) }}</span></label>
                        <button type="button" class="ee-ms-clear" @click="sel = []">{{ $t('editor_espacio.ms.clear') }}</button>
                    </div>
                    <div v-if="cargando" class="ee-cargando-s"><HyFLoader variant="inline" /></div>
                    <ul v-else id="msList" class="ee-ms-list">
                        <li v-for="e in visibles" :key="e.idalojamiento" :class="['ee-msr', { 'is-on': sel.includes(e.idalojamiento), 'is-na': accion && !calcular(e).aplica }]">
                            <label class="ee-msr-ck"><input type="checkbox" :data-id="e.idalojamiento" :checked="sel.includes(e.idalojamiento)" :aria-label="$t('editor_espacio.ms.choose', { x: tituloDe(e), id: e.idalojamiento })" @change="alternar(e.idalojamiento)"><span class="ee-ck-box" aria-hidden="true" v-html="ICON.check"></span></label>
                            <img class="ee-msr-img" :src="e.foto ? S3 + e.foto : ''" alt="" loading="lazy">
                            <span class="ee-msr-b">
                                <span class="ee-msr-t">{{ tituloDe(e) }} <em v-if="e.idalojamiento === desde" class="ee-msr-me">{{ $t('editor_espacio.ms.this_space') }}</em></span>
                                <span class="ee-msr-m">{{ e.direccion }} · ID {{ e.idalojamiento }}<template v-if="e.idcodigo"> · {{ e.idcodigo }}</template><template v-if="!aprobadoDe(e)"> · <span class="ee-msr-w">{{ $t('editor_espacio.in_review') }}</span></template></span>
                            </span>
                            <span class="ee-msr-pv">
                                <template v-if="accion">
                                    <span v-if="!calcular(e).aplica" class="ee-pv ee-pv--no">{{ calcular(e).motivo }}</span>
                                    <span v-else-if="calcular(e).lista" class="ee-pv ee-pv--chg">{{ calcular(e).despues }}</span>
                                    <span v-else class="ee-pv"><s>{{ calcular(e).antes }}</s><span class="ee-pv-ar" :aria-label="$t('editor_espacio.ms.becomes')">→</span><b :class="{ 'is-down': calcular(e).sube === false }">{{ calcular(e).despues }}</b></span>
                                    <span v-if="calcular(e).aplica && calcular(e).garantia" class="ee-pv-g">{{ calcular(e).garantia }}</span>
                            <span v-if="calcular(e).aplica && calcular(e).alerta" class="ee-pv-al"><span v-html="ICON.info"></span>{{ calcular(e).alerta }}</span>
                                </template>
                            </span>
                        </li>
                        <li v-if="!visibles.length" class="ee-empty"><p class="ee-empty-title">{{ $t(lista.length ? 'editor_espacio.ms.empty' : 'editor_espacio.ms.no_spaces') }}</p><p class="ee-empty-text">{{ $t(lista.length ? 'editor_espacio.ms.empty_x' : 'editor_espacio.ms.no_spaces_x') }}</p></li>
                    </ul>
                </section>

                <div class="ee-bar ee-ms-bar" role="region" :aria-label="$t('editor_espacio.ms.apply_region')">
                    <span :class="['ee-bar-state', cambian.length && accion ? 'is-dirty' : 'is-idle']">{{ estado }}</span>
                    <div class="ee-bar-actions"><button id="msGo" type="button" class="ee-btn ee-btn--primary" :disabled="!accion || !cambian.length || !listoParams" @click="$refs.capas.abrirModal('confirmar', { ancho: true })">{{ accion && cambian.length && listoParams ? $tc('editor_espacio.ms.apply_n', cambian.length, { n: cambian.length }) : $t('editor_espacio.ms.review') }}</button></div>
                </div>
            </div>
        </div>

        <EeCapas ref="capas">
            <template #confirmar>
                <div class="ee-modal-ico" v-html="ICON[(acciones.find(a => a.id === accion) || {}).icon || 'layers']"></div>
                <h2 id="ee-modal-t" class="ee-modal-title">{{ $t(`editor_espacio.ms.a.${accion}`) }}: {{ resumenParams }}</h2>
                <p class="ee-modal-text">{{ $tc('editor_espacio.ms.confirm_x', cambian.length, { n: cambian.length }) }}<template v-if="elegidos.length - cambian.length"> {{ $tc('editor_espacio.ms.confirm_rest', elegidos.length - cambian.length, { n: elegidos.length - cambian.length }) }}</template> {{ $t('editor_espacio.ms.confirm_undo') }}</p>
                <ul class="ee-mc-list">
                    <li v-for="e in cambian.slice(0, 5)" :key="e.idalojamiento"><span>{{ tituloDe(e) }} <small>ID {{ e.idalojamiento }}</small></span><b>{{ calcular(e).despues }}<template v-if="calcular(e).garantia"> · {{ calcular(e).garantia }}</template></b></li>
                    <li v-if="cambian.length > 5" class="ee-mc-more">{{ $t('editor_espacio.ms.and_more', { n: cambian.length - 5 }) }}</li>
                </ul>
                <div v-if="aplicando" class="ee-mc-prog"><span class="ee-mc-bar"><i :style="{ width: (avance.total > 1 ? Math.max(8, Math.round(avance.hechos / avance.total * 100)) : 60) + '%' }"></i></span><span>{{ avance.total > 1 ? $t('editor_espacio.ms.applying_n', { a: avance.hechos, b: avance.total }) : $t('editor_espacio.ms.applying') }}</span></div>
                <div v-else class="ee-modal-acts"><button type="button" class="ee-btn ee-btn--ghost" @click="$refs.capas.cerrarModal()">{{ $t('editor_espacio.cancel') }}</button><button id="mcOk" type="button" class="ee-btn ee-btn--primary" autofocus @click="aplicar">{{ $t('editor_espacio.ms.apply') }}</button></div>
            </template>
        </EeCapas>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import EeContador from '@/components/EditorEspacio/EeContador.vue';
import EeTexto from '@/components/EditorEspacio/EeTexto.vue';
import EeCapas from '@/components/EditorEspacio/EeCapas.vue';
import { ICON, amen } from '@/components/EditorEspacio/iconos';
import categorias from '@/components/Banner/Category.json';
import {
    MODALIDADES, GARANTIA_MESES, GARANTIA_PAGO, COMODIDADES, CERCANO, TEXTOS, MONEDAS_RESPALDO, MONEDAS_FUERA,
    dinero, num, CONTACTO, aHtml,
} from '@/components/EditorEspacio/datos';
import { htmlATexto } from '@/Utils/textoIdiomas';
import { avisar } from '@/Utils/notificaciones';

const API = process.env.VUE_APP_API_URL;
/** Espacios por pedido: igual a EdicionMasivaController::MAX_IDS. */
const LOTE = 500;

/**
 * "Deshacer" de una edición masiva. Vive fuera del componente porque se usa
 * desde el aviso cuando ya se volvió a Mis espacios: al terminar avisa y, si
 * se está en Mis espacios, la recarga para que se vean los valores de antes.
 * Acepta un token o varios (cuando se aplicó en tandas).
 */
async function deshacerMasivo(token, i18n, router) {
    const tokens = Array.isArray(token) ? token : [token];
    let ok = 0;
    for (const t of tokens) {
        try {
            await axios.post(`${API}accommodations/masivo/deshacer`, { token: t });
            ok++;
        } catch (e) { /* vencido o ya deshecho: se sigue con los demás */ }
    }
    if (ok) {
        avisar({ tipo: 'info', titulo: i18n.t('editor_espacio.ms.t_undone') });
        window.dispatchEvent(new CustomEvent('hyf:espacios-cambiaron'));
    } else {
        avisar({ tipo: 'error', titulo: i18n.t('editor_espacio.ms.t_undo_late') });
    }
    if (router.currentRoute.name !== 'my-accommodations') router.push({ name: 'my-accommodations' }).catch(() => {});
}
const ACCIONES = [
    { id: 'precio', icon: 'money' }, { id: 'estadia', icon: 'calendar' }, { id: 'modalidad', icon: 'repeat' },
    { id: 'garantia', icon: 'shield' }, { id: 'huespedes', icon: 'users' }, { id: 'reglas', icon: 'rules' },
    { id: 'sobre', icon: 'people' }, { id: 'comodidades', icon: 'spark' }, { id: 'cercano', icon: 'pin' },
];
const CAMPOS = [
    { v: 'arriendo', l: 'wizard.s2.property-expense' }, { v: 'arriendo_diario', l: 'editor_espacio.ms.night_price' },
    { v: 'arriendo_basicos', l: 'wizard.s2.basic-services' }, { v: 'arriendo_comunes', l: 'wizard.s2.common-expenses' },
];

export default {
    name: 'EditarVarios',
    components: { HyFLoader, EeContador, EeTexto, EeCapas },
    data() {
        return {
            ICON, amen, MODALIDADES, GARANTIA_MESES, GARANTIA_PAGO, TEXTOS, CAMPOS,
            S3: process.env.VUE_APP_S3_URL,
            cargando: true, lista: [], modeloGarantia: false,
            accion: null, p: {}, sel: [], desde: null,
            f: { q: '', estado: 'todos', ciudad: '', tipo: '' },
            aplicando: false,
            // Avance cuando se aplica en varios pedidos (la API acepta hasta LOTE por pedido)
            avance: { hechos: 0, total: 0 },
        };
    },
    computed: {
        ...mapState('exchange', ['currencyConversionTable']),
        acciones() { return ACCIONES.filter(a => a.id !== 'garantia' || this.modeloGarantia); },
        monedas() {
            const t = (this.currencyConversionTable || []).map(m => m.moneda).filter(m => m && !MONEDAS_FUERA.includes(m));
            const enUso = [...new Set(this.lista.map(e => e.moneda).filter(m => m && !MONEDAS_FUERA.includes(m)))];
            return [...new Set([...enUso, ...(t.length ? t : MONEDAS_RESPALDO)])];
        },
        ciudades() { return [...new Set(this.lista.map(this.ciudadDe).filter(Boolean))].sort(); },
        visibles() {
            const q = this.f.q.trim().toLowerCase();
            return this.lista.filter(e =>
                (this.f.estado === 'todos' || (this.f.estado === 'ok' ? this.aprobadoDe(e) : !this.aprobadoDe(e))) &&
                (!this.f.ciudad || this.ciudadDe(e) === this.f.ciudad) && (!this.f.tipo || e.tipo === this.f.tipo) &&
                (!q || [this.tituloDe(e), e.idalojamiento, e.idcodigo, e.direccion].join(' ').toLowerCase().includes(q)));
        },
        todosVisibles() { return this.visibles.length > 0 && this.visibles.every(e => this.sel.includes(e.idalojamiento)); },
        elegidos() { return this.lista.filter(e => this.sel.includes(e.idalojamiento)); },
        cambian() { return this.accion ? this.elegidos.filter(e => this.calcular(e).aplica) : []; },
        gruposTri() {
            if (this.accion === 'cercano') return [{ grupo: 'cercano', titulo: this.$t('editor_espacio.sec.cercano'), items: CERCANO.map(([k, l, ic]) => [k, `wizard.s6.${l}`, ic]) }];
            return COMODIDADES.map(g => ({ grupo: g.grupo, titulo: this.$t(`editor_espacio.am.${g.grupo}`), items: g.items.map(([k, l, ic]) => [k, `wizard.s4.${l}`, ic]) }));
        },
        listoParams() { return this.resumenParams !== this.$t('editor_espacio.ms.incomplete'); },
        resumenParams() {
            const p = this.p, falta = this.$t('editor_espacio.ms.incomplete');
            switch (this.accion) {
                case 'precio': {
                    if (p.valor === '' || p.valor === null || !isFinite(+p.valor)) return falta;
                    const c = this.$t(CAMPOS.find(x => x.v === p.campo).l);
                    return p.modo === 'pct' ? `${c} ${+p.valor >= 0 ? '+' : ''}${p.valor} %${p.moneda ? ' · ' + p.moneda : ''}${this.resumenGarantia()}` : p.modo === 'monto' ? `${c} ${+p.valor >= 0 ? '+' : ''}${p.valor} ${p.moneda}${this.resumenGarantia()}` : `${c}: ${dinero(p.valor, p.moneda)}${this.resumenGarantia()}`;
                }
                case 'estadia': return this.$tc('editor_espacio.nights', p.valor, { n: p.valor });
                case 'huespedes': return this.$t('editor_espacio.ms.max_n', { n: p.valor });
                case 'modalidad': return this.$t(`editor_espacio.mod.${p.valor}`);
                case 'garantia': return `${this.mesesNum(p.meses)} ${this.mesesUnidad(p.meses)}`;
                case 'reglas': { const k = Object.keys(p.textos); return k.length && k.every(x => String(p.textos[x]).trim() && !CONTACTO.test(p.textos[x])) ? `${this.$tc('editor_espacio.ms.n_texts', k.length, { n: k.length })} · ${this.$t('editor_espacio.ms.text_' + p.modo).toLowerCase()}` : falta; }
                case 'sobre': return String(p.valor).trim() && !CONTACTO.test(p.valor) ? this.$t('editor_espacio.ms.text_' + p.modo) : falta;
                case 'comodidades': case 'cercano': { const n = Object.keys(p.cambios).length; return n ? this.$tc('editor_espacio.n_changes_plain', n, { n }) : falta; }
            }
            return '';
        },
        estado() {
            if (!this.accion) return this.$t('editor_espacio.ms.st_choose');
            if (!this.elegidos.length) return this.$t('editor_espacio.ms.st_none');
            if (!this.cambian.length) return this.$tc('editor_espacio.ms.st_nothing', this.elegidos.length, { n: this.elegidos.length });
            return this.cambian.length === this.elegidos.length
                ? this.$tc('editor_espacio.ms.st_all', this.cambian.length, { n: this.cambian.length })
                : this.$t('editor_espacio.ms.st_some', { n: this.cambian.length, m: this.elegidos.length });
        },
    },
    methods: {
        mesesNum(m) { return String(m).replace('.', this.$i18n.locale === 'en' ? '.' : ','); },
        mesesUnidad(m) {
            m = num(m);
            return m === 0 ? this.$t('wizard.s2.guarantee-none') : m === 0.5 ? this.$t('wizard.s2.guarantee-half') : m === 1 ? this.$t('wizard.s2.guarantee-one') : this.$t('wizard.s2.guarantee-many');
        },
        aprobadoDe(e) { return e.aprobado === 1 || e.aprobado === '1'; },
        ciudadDe(e) {
            const partes = String(e.direccion || '').split(',').map(x => x.trim()).filter(Boolean);
            if (partes.length < 2) return '';
            return partes[partes.length - 2].replace(/\b\d{3,}\b/g, '').trim();
        },
        tituloDe(e) {
            const c = categorias.find(x => x.value === e.categoria);
            const cat = c ? this.$t(c.translated) : (e.categoria || '');
            return e.tipo === 'entero' ? this.$t('editor_espacio.title_entire', { c: cat }) : this.$t('editor_espacio.title_room', { c: cat.toLowerCase() });
        },
        inicial(id) {
            return {
                precio: { campo: 'arriendo', modo: 'pct', valor: '', moneda: '', gMeses: '', gPago: '15_dias_antes' },
                estadia: { valor: 3 }, huespedes: { valor: 2 }, modalidad: { valor: 'ambos' },
                garantia: { meses: 1, pago: '15_dias_antes' },
                reglas: { textos: { reglas: '' }, modo: 'reemplazar' },
                sobre: { valor: '', modo: 'reemplazar' },
                comodidades: { cambios: {} }, cercano: { cambios: {} },
            }[id];
        },
        elegirAccion(id) {
            this.accion = id;
            this.p = this.inicial(id);
            this.$nextTick(() => document.getElementById('msC2').scrollIntoView({ behavior: 'smooth', block: 'start' }));
        },
        /** " · garantía 1 mes" si se eligió garantía junto con el precio. */
        resumenGarantia() {
            const p = this.p;
            if (!this.modeloGarantia || p.campo === 'arriendo_diario' || p.gMeses === '' || p.gMeses === undefined) return '';
            const gm = num(p.gMeses);
            return ' · ' + this.$t('editor_espacio.ms.g_short', { x: gm ? `${this.mesesNum(gm)} ${this.mesesUnidad(gm)}` : this.$t('wizard.s2.guarantee-none') });
        },
        /** Moneda más usada entre los elegidos (o en toda la lista). */
        monedaMasUsada() {
            const base = this.elegidos.length ? this.elegidos : this.lista;
            const freq = Object.entries(base.reduce((a, e) => (a[e.moneda] = (a[e.moneda] || 0) + 1, a), {}))
                .filter(([m]) => this.monedas.includes(m)).sort((a, b) => b[1] - a[1]);
            return freq.length ? freq[0][0] : (this.monedas[0] || 'USD');
        },
        /** Fijar y Sumar necesitan una moneda; con % se puede dejar la de cada unidad. */
        elegirModo(m) {
            this.p.modo = m;
            this.p.valor = '';
            if (m !== 'pct' && !this.p.moneda) this.p.moneda = this.monedaMasUsada();
        },
        /** Igual que la API: tipo_cambio = unidades de cada moneda por 1 USD. */
        convertir(monto, de, a) {
            if (de === a) return monto;
            const c = {};
            (this.currencyConversionTable || []).forEach(x => { if (+x.cambio > 0) c[x.moneda] = +x.cambio; });
            if (!c[de] || !c[a]) return null;
            return monto / c[de] * c[a];
        },
        alternarTexto(t, on) {
            const x = { ...this.p.textos };
            if (on) x[t] = x[t] || ''; else delete x[t];
            this.p.textos = x;
        },
        alternarTri(k, v) {
            const c = { ...this.p.cambios };
            if (v) c[k] = v; else delete c[k];
            this.p.cambios = c;
        },
        alternar(id) { this.sel = this.sel.includes(id) ? this.sel.filter(x => x !== id) : [...this.sel, id]; },
        elegirVisibles(on) {
            const ids = this.visibles.map(e => e.idalojamiento);
            this.sel = on ? [...new Set([...this.sel, ...ids])] : this.sel.filter(x => !ids.includes(x));
        },

        /* ¿Le cambia algo a este espacio? Mismas reglas que la API (EdicionMasivaController::calcular). */
        calcular(e) {
            const p = this.p, no = motivo => ({ aplica: false, motivo });
            const mod = e.modalidad_tiempo;
            const dif = (antes, despues, cambia, extra = {}) => ({ aplica: cambia, motivo: cambia ? '' : this.$t('editor_espacio.ms.why.same'), antes, despues, ...extra });
            switch (this.accion) {
                case 'precio': {
                    const k = p.campo, v0 = parseFloat(String(p.valor).replace(',', '.'));
                    // Montos siempre enteros (fijar / sumar); el % puede tener decimales,
                    // pero el precio que queda se redondea a entero igual.
                    const v = p.modo === 'pct' ? v0 : Math.round(v0);
                    if (k === 'arriendo_diario' && mod === 'mensual') return no(this.$t('editor_espacio.ms.why.no_daily'));
                    if (k !== 'arriendo_diario' && mod === 'diario') return no(this.$t('editor_espacio.ms.why.no_monthly'));
                    if (!isFinite(v)) return no(this.$t('editor_espacio.ms.why.missing'));
                    // Moneda en que se guarda (vacía = la de cada unidad, solo con %).
                    // Si es otra, se convierte con tipo_cambio igual que la API.
                    const destino = p.moneda || e.moneda;
                    const actual = k === 'arriendo' ? num(e.arriendo_neto) : num(e[k]);
                    let antes = actual;
                    if (destino !== e.moneda) {
                        const x = this.convertir(actual, e.moneda, destino);
                        if (x === null) return no(this.$t('editor_espacio.ms.no_rate', { m: e.moneda }));
                        antes = Math.round(x);
                    }
                    let n = p.modo === 'fijar' ? v : p.modo === 'pct' ? antes * (1 + v / 100) : antes + v;
                    n = Math.max(0, Math.round(n));
                    if (k === 'arriendo' && n <= 0) return no(this.$t('editor_espacio.ms.why.zero'));
                    const pasa = destino !== e.moneda;
                    // Garantía elegida junto con el precio (vacía = la de cada unidad)
                    const conG = this.modeloGarantia && k !== 'arriendo_diario' && p.gMeses !== '' && p.gMeses !== undefined;
                    const gm = conG ? num(p.gMeses) : null;
                    const cambiaG = conG && (num(e.garantia_meses) !== gm || (gm > 0 && e.garantia_pago !== p.gPago));
                    const gTxt = conG ? ' · ' + this.$t('editor_espacio.ms.g_short', { x: gm ? `${this.mesesNum(gm)} ${this.mesesUnidad(gm)}` : this.$t('wizard.s2.guarantee-none') }) : '';
                    const r = dif(dinero(actual, e.moneda), dinero(n, destino), n !== antes || pasa || cambiaG, { sube: n > antes, garantia: gTxt.replace(/^ · /, '') });
                    if (pasa) r.alerta = this.$t('editor_espacio.ms.converted', { de: e.moneda, a: destino });
                    return r;
                }
                case 'estadia':
                    if (mod === 'mensual') return no(this.$t('editor_espacio.ms.why.monthly30'));
                    return dif(this.$tc('editor_espacio.nights', e.tiempo_min, { n: e.tiempo_min }), this.$tc('editor_espacio.nights', p.valor, { n: p.valor }), +e.tiempo_min !== +p.valor);
                case 'huespedes':
                    return dif(String(e.maximo_huespedes), String(p.valor), +e.maximo_huespedes !== +p.valor);
                case 'modalidad': {
                    const r = dif(this.$t(`editor_espacio.mod.${mod}`), this.$t(`editor_espacio.mod.${p.valor}`), mod !== p.valor);
                    if (r.aplica && p.valor !== 'mensual' && !(num(e.arriendo_diario) > 0)) r.alerta = this.$t('editor_espacio.ms.why.no_daily_price');
                    if (r.aplica && p.valor !== 'diario' && !(num(e.arriendo_neto) > 0)) r.alerta = this.$t('editor_espacio.ms.why.no_monthly_price');
                    return r;
                }
                case 'garantia': {
                    if (mod === 'diario') return no(this.$t('editor_espacio.ms.why.daily_only'));
                    const t = (m, pg) => num(m) ? `${this.mesesNum(m)} ${this.mesesUnidad(m)}${pg ? ' · ' + this.$t(`wizard.s2.guarantee-when-${pg}`).toLowerCase() : ''}` : this.$t('wizard.s2.guarantee-none');
                    const antes = num(e.garantia_meses), meses = num(p.meses);
                    const cambia = antes !== meses || (meses > 0 && e.garantia_pago !== p.pago);
                    return dif(t(antes, antes ? e.garantia_pago : null), t(meses, meses ? p.pago : null), cambia);
                }
                case 'reglas': case 'sobre': {
                    const tx = this.accion === 'sobre' ? { sobre_nosotros: p.valor } : p.textos;
                    const ks = Object.keys(tx);
                    if (!ks.length) return no(this.$t('editor_espacio.ms.why.pick_text'));
                    if (ks.some(k => !String(tx[k]).trim())) return no(this.$t('editor_espacio.ms.why.missing_text'));
                    if (ks.some(k => CONTACTO.test(tx[k]))) return no(this.$t('editor_espacio.ms.why.contact'));
                    const cambia = ks.some(k => {
                        const actual = String(e[k] || '').trim();
                        const nuevo = p.modo === 'agregar' ? (actual + aHtml(tx[k])).trim() : aHtml(tx[k]);
                        return nuevo !== actual;
                    });
                    const corto = s => { s = htmlATexto(s || '').replace(/\s+/g, ' ').trim(); return s.length > 60 ? s.slice(0, 58) + '…' : (s || this.$t('editor_espacio.ms.empty_text')); };
                    return { aplica: cambia, motivo: cambia ? '' : this.$t('editor_espacio.ms.why.same_text'), antes: corto(e[ks[0]]), despues: this.$t(p.modo === 'agregar' ? 'editor_espacio.ms.will_append' : 'editor_espacio.ms.will_replace') + (ks.length > 1 ? ` (${ks.length})` : ''), texto: true };
                }
                case 'comodidades': case 'cercano': {
                    const ks = Object.keys(p.cambios);
                    if (!ks.length) return no(this.$t('editor_espacio.ms.why.pick_change'));
                    const L = {};
                    [...COMODIDADES.flatMap(g => g.items.map(([k, l]) => [k, `wizard.s4.${l}`])), ...CERCANO.map(([k, l]) => [k, `wizard.s6.${l}`])].forEach(([k, l]) => { L[k] = this.$t(l); });
                    const mas = [], menos = [];
                    ks.forEach(k => { const v = p.cambios[k] === 'agregar' ? 1 : 0; if ((+e[k] || 0) !== v) (v ? mas : menos).push(L[k]); });
                    if (!mas.length && !menos.length) return no(this.$t('editor_espacio.ms.why.already'));
                    return { aplica: true, antes: '', despues: [mas.length ? '+ ' + mas.join(', ') : '', menos.length ? '− ' + menos.join(', ') : ''].filter(Boolean).join(' · '), lista: true };
                }
            }
            return no('');
        },

        params() {
            const p = this.p;
            switch (this.accion) {
                case 'precio': {
                    const v = parseFloat(String(p.valor).replace(',', '.'));
                    const conG = this.modeloGarantia && p.campo !== 'arriendo_diario' && p.gMeses !== '' && p.gMeses !== undefined;
                    return {
                        campo: p.campo, modo: p.modo, valor: p.modo === 'pct' ? v : Math.round(v), moneda: p.moneda || null,
                        garantia_meses: conG ? num(p.gMeses) : null,
                        garantia_pago: conG && num(p.gMeses) > 0 ? p.gPago : null,
                    };
                }
                case 'garantia': return { meses: num(p.meses), pago: num(p.meses) > 0 ? p.pago : null };
                default: return p;
            }
        },
        async aplicar() {
            const ids = this.cambian.map(e => e.idalojamiento);
            // La API acepta hasta LOTE por pedido: con más (p. ej. "Todas mis
            // unidades") se manda en tandas y se junta el resultado.
            const lotes = [];
            for (let i = 0; i < ids.length; i += LOTE) lotes.push(ids.slice(i, i + LOTE));
            this.aplicando = true;
            this.avance = { hechos: 0, total: ids.length };
            const cambiados = [], errores = [], tokens = [];
            let fallo = null;
            try {
                for (const lote of lotes) {
                    try {
                        const { data } = await axios.post(`${API}accommodations/masivo`, { accion: this.accion, params: this.params(), ids: lote });
                        cambiados.push(...(data.cambiados || []));
                        errores.push(...(data.errores || []));
                        if (data.deshacer) tokens.push(data.deshacer);
                    } catch (e) {
                        // Si falla una tanda, las anteriores ya quedaron guardadas: se corta acá
                        // y se avisa (con Deshacer de lo que sí se aplicó).
                        fallo = e;
                        break;
                    }
                    this.avance = { hechos: Math.min(ids.length, this.avance.hechos + lote.length), total: ids.length };
                }
                this.$refs.capas.cerrarModal();
                const n = cambiados.length, err = errores.length;
                if (n) {
                    // Listo: aviso (mismo cartel que las notificaciones; también queda en la
                    // campana, lo crea la API) y vuelta a Mis espacios. "Deshacer" sigue
                    // funcionando desde el aviso aunque ya no se esté en esta pantalla.
                    const i18n = this.$i18n, router = this.$router;
                    const msgFallo = fallo ? ' ' + ((fallo.response && fallo.response.data && fallo.response.data.message) || this.$t('editor_espacio.t.save_error')) : '';
                    avisar({
                        tipo: fallo ? 'error' : 'ok',
                        titulo: this.$t('editor_espacio.ms.t_done_t'),
                        cuerpo: this.$tc('editor_espacio.ms.t_done', n, { n }) + (err ? ' ' + this.$tc('editor_espacio.ms.t_errors', err, { n: err }) : '') + msgFallo,
                        accion: tokens.length ? { label: this.$t('editor_espacio.undo'), fn: () => deshacerMasivo(tokens, i18n, router) } : null,
                        duracion: tokens.length ? 12000 : null,
                    });
                    this.$router.push({ name: 'my-accommodations' });
                    return;
                }
                if (fallo) throw fallo;
                await this.cargarLista(false);
                if (err) this.$refs.capas.toast(this.$tc('editor_espacio.ms.t_errors', err, { n: err }), 'error');
                else this.$refs.capas.toast(this.$t('editor_espacio.ms.t_nothing'), 'info');
            } catch (e) {
                console.error('[EditarVarios] no se pudo aplicar', e);
                this.$refs.capas.cerrarModal();
                const msg = e.response && e.response.data && e.response.data.message;
                this.$refs.capas.toast(msg || this.$t('editor_espacio.t.save_error'), 'error');
            } finally {
                this.aplicando = false;
                this.avance = { hechos: 0, total: 0 };
            }
        },
        async deshacer(token) {
            await deshacerMasivo(token, this.$i18n, this.$router);
        },
        async cargarLista(primeraVez = true) {
            if (primeraVez) this.cargando = true;
            try {
                const { data } = await axios.get(`${API}accommodations/masivo`);
                this.lista = data.data || [];
                this.modeloGarantia = !!data.modelo_garantia;
            } catch (e) {
                console.error('[EditarVarios] no se pudo leer la lista', e);
                this.$refs.capas.toast(this.$t('editor_espacio.ms.t_load_error'), 'error');
            } finally {
                this.cargando = false;
            }
        },
    },
    async created() {
        await this.cargarLista();
        const existen = new Set(this.lista.map(e => e.idalojamiento));
        if (this.$route.query.todos === '1') {
            // "Todas mis unidades" desde Mis espacios
            this.sel = [...existen];
        } else {
            const ids = String(this.$route.query.ids || '').split(',').map(x => parseInt(x, 10)).filter(Boolean);
            this.sel = ids.filter(id => existen.has(id));
        }
        let pre = null;
        try { pre = JSON.parse(sessionStorage.getItem('ee_preset') || 'null'); } catch (e) { pre = null; }
        sessionStorage.removeItem('ee_preset');
        if (pre && this.acciones.some(a => a.id === pre.tipo)) {
            const { tipo, desde, ...rest } = pre;
            this.accion = tipo;
            this.p = { ...this.inicial(tipo), ...rest };
            if (this.accion === 'reglas' && this.p.textos) this.p.textos = { ...this.p.textos };
            this.desde = desde || null;
        }
        this.$nextTick(() => this.$refs.titulo && this.$refs.titulo.focus({ preventScroll: true }));
    },
};
</script>

<style src="../../components/EditorEspacio/editorEspacio.css"></style>
<style src="../../components/EditorEspacio/editorAncho.css"></style>
<style>
.ee .ee-cargando-s { display: grid; place-items: center; min-height: 200px; }
.ee .ee-i { display: inline-flex; font-style: normal; }
.ee .ee-ms-desde > span:first-child, .ee .ee-search > span, .ee .ee-pv-al > span, .ee .ee-ed-note > span:first-child { display: flex; }
.ee .ee-search > span svg { position: absolute; left: 16px; top: 50%; width: 18px; height: 18px; transform: translateY(-50%); color: var(--muted); pointer-events: none; }
.ee .ee-ed-note > span:first-child svg { width: 20px; height: 20px; color: var(--orange-600); }
/* El texto de los avisos se ajusta al ancho de la tarjeta (antes se salía por la derecha) */
.ee .ee-ed-note > span:last-child { flex: 1 1 auto; min-width: 0; white-space: normal; overflow-wrap: anywhere; }
/* Vista previa: la garantía va en su propia línea y el "después" puede partirse en celular */
.ee .ee-pv-g { display: block; margin-top: 2px; font-size: 12.5px; font-weight: 600; color: var(--orange-600); }
@media (max-width: 720px) { .ee .ee-pv { flex-wrap: wrap; white-space: normal; row-gap: 2px; } .ee .ee-pv > * { white-space: nowrap; } }
/* Garantía dentro de Precio: "La de cada unidad" + 5 opciones de meses */
.ee .ee-ms-gar { margin-top: 18px; }
.ee .ee-mo--keep { grid-template-columns: minmax(0, 1.6fr) repeat(5, minmax(0, 1fr)); }
.ee .ee-mo-o--keep small { font-size: 11.5px; }
@media (max-width: 720px) {
    .ee .ee-mo--keep { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .ee .ee-mo--keep .ee-mo-o--keep { grid-column: 1 / -1; }
    .ee .ee-mo--keep .ee-mo-o--keep span { min-height: 48px; flex-direction: row; gap: 8px; }
}
.ee .ee-ms-desde > span:first-child svg { width: 20px; height: 20px; color: var(--orange-600); }
.ee .ee-btn span, .ee .ee-crumb-back span { display: inline-flex; }
</style>
